
















import { Component, Vue, Prop } from "vue-property-decorator";

import EntityFiles from "@/components/fileManager/EntityFiles.vue";
import { Registration as IRegistration } from "@/api-v2/course/models/registration";
import { Attachment as IAttachment } from "@/api-v2/course/models/attachment";
import courseRegistrations from "@/getinfo-api/courseRegistrations";
import { courseApi } from "@/getinfo-api";

@Component({
  components: { EntityFiles }
})
export default class UserStudentFiles extends Vue {
  @Prop() studentId!: string;
  @Prop() registrationId!: string;
  @Prop() listenerId!: string;
  @Prop() courseId!: string;
  @Prop({ default: true }) isShowFileManagerButton!: boolean;
  isLoading: boolean = false;
  registration!: IRegistration;
  attachments: IAttachment[] = [];

  data() {
    return {
      registration: undefined
    };
  }

  get union(): { id: string; mode: "v1" | "v2" } | null {
    if (this.listenerId) {
      return { id: this.listenerId, mode: "v1" };
    }
    if (this.registrationId) {
      return { id: this.registrationId, mode: "v2" };
    }
    if (this.studentId && this.registration) {
      return { id: this.registration.id, mode: "v2" };
    }
    return null;
  }

  async addFiles(fileIds: string[]) {
    this.isLoading = true;
    await courseApi.Attachment.editCourseRegistrationAttachedFiles(
      this.union?.id!,
      this.union?.mode!,
      fileIds.map(fileId => {
        return { id: fileId };
      })
    );
    await this.getAttachments(this.union?.id!);
    this.isLoading = false;
  }

  async getAttachments(id: string) {
    const {
      data
    } = await courseApi.Attachment.getCourseRegistrationAttachedFiles(id);

    this.attachments = data;
  }

  async init() {
    this.isLoading = true;
    if (this.studentId) {
      const { data } = await courseRegistrations({
        studentIds: [this.studentId],
        courseIds: [this.courseId]
      });
      this.registration = data.items[0];
    }
    await this.getAttachments(this.union?.id!);
    this.isLoading = false;
  }

  mounted() {
    this.init();
  }
}
